import { render, staticRenderFns } from "./AllocationChart.vue?vue&type=template&id=98d34d58&"
import script from "./AllocationChart.vue?vue&type=script&lang=js&"
export * from "./AllocationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports